import TagUsageCard from 'routes/TagsAnalytics/TagUsageCard/TagUsageCard';

export default TagUsageCard;
